module.exports = __webpack_public_path__ + "static/media/fb.2849e3dd.svg";